import React from 'react';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

export const US_STATES = [
  ['AL','AL'],['AK','AK'],['AZ','AZ'],['AR','AR'],['CA','CA'],['CO','CO'],['CT','CT'],['DE','DE'],
  ['DC','DC'],['FL','FL'],['GA','GA'],['HI','HI'],['ID','ID'],['IL','IL'],['IN','IN'],['IA','IA'],
  ['KS','KS'],['KY','KY'],['LA','LA'],['ME','ME'],['MD','MD'],['MA','MA'],['MI','MI'],['MN','MN'],
  ['MS','MS'],['MO','MO'],['MT','MT'],['NE','NE'],['NV','NV'],['NH','NH'],['NJ','NJ'],['NM','NM'],
  ['NY','NY'],['NC','NC'],['ND','ND'],['OH','OH'],['OK','OK'],['OR','OR'],['PA','PA'],['RI','RI'],
  ['SC','SC'],['SD','SD'],['TN','TN'],['TX','TX'],['UT','UT'],['VT','VT'],['VA','VA'],['WA','WA'],
  ['WV','WV'],['WI','WI'],['WY','WY'],
];

export default function StateSelect({ label = 'State', value, onChange, testId }) {
  return (
    <div>
      {label && <Label className="text-xs text-slate-500">{label}</Label>}
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className={label ? 'mt-1' : ''} data-testid={testId}><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-64">
          {US_STATES.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
